export const USER_BOOKMARKS_QUERY = `
  query getUserBookmarks($bconnectId: ID!) {
    userBookmarks(bconnectId: $bconnectId) {
      bookmarks {
        contentId
        contentType
        id
        publishedDate
        readDate
        savedDate
      }
    }
  }
`;

export const USER_PROFILE_QUERY = `
  query getUserProfile($userIdentity: UserIdentityInput) {
    user(userIdentity: $userIdentity) {
      profile {
        industry
        jobTitle
      }
    }
  }
`;
